<template>
    <ElDialog
        class="modal" 
        :visible.sync="showModal" 
        :width="modalWidth">
        <h2 class="modal__title">
            Ссылка на оплату отправлена
        </h2>
        <div class="modal__body">
            <p class="modal__text">
                Мы отправили ссылку на оплату по номеру,
                <br>
                указанному Вами в форме.
            </p>
        </div>
        <div class="modal__submit-buttons">
            <BaseButton text="Закрыть окно" 
                size="large" 
                @click.native="closeModal" />
        </div>
    </ElDialog>
</template>

<script>
import modal from "@/mixins/modal";
import BaseButton from '@/components/ui/BaseButton';

export default {
    name: 'ModalPolicyIssuanceError',
    components: {
        BaseButton
    },
    mixins: [modal]
}
</script>